import React from 'react';
import {Button} from 'reactstrap';
import cx from 'classnames';
import styles from './SectionContentsCta.module.scss';

function SectionContentsCta(props) {
  const {className, outline, ...rest} = props;

  return (
    <Button
      color="primary"
      {...rest}
      className={cx(styles['promotion-cta'], className, {
        [styles['promotion-cta--outline']]: outline,
      })}
    />
  );
}

export default SectionContentsCta;
